import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=50e58705&lang=pug"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchSelect.vue?vue&type=style&index=0&id=50e58705&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports